module.exports = __webpack_public_path__ + "img/liveplus_logo_348x100.303169ee.png";